import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Avatar, Image } from 'antd';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ImageStyled = styled(Image)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  border: 1px solid lightgray;\n"])));
export var ProfileImage = function ProfileImage(props) {
  var src = props.src,
      alt = props.alt,
      placeholder = props.placeholder,
      size = props.size,
      style = props.style,
      shape = props.shape,
      isBigSize = props.isBigSize;

  var styles = _objectSpread(_objectSpread({}, style), {}, {
    border: '0.5px solid lightgray',
    backgroundColor: '#e38b2d',
    transform: isBigSize ? 'scale(4)' : 'none',
    transformOrigin: 'left top',
    userSelect: 'none'
  });

  var renderProfileImageBySourcePath = function renderProfileImageBySourcePath() {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: src ? /*#__PURE__*/_jsx(ImageStyled, {
        src: src
      }) : /*#__PURE__*/_jsx(Avatar, {
        style: styles,
        alt: alt,
        size: size,
        shape: shape,
        children: placeholder
      })
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderProfileImageBySourcePath()
  });
};